import React from "react";
import { motion } from "motion/react";

import { pagePreset, reduced } from "./motionPresets";

/**
 * Wraps the routed page content so every navigation gets the same entrance.
 *
 * Mounted once at the layout level in App.js, keyed by pathname, so switching
 * route re-runs the animation without touching the router configuration.
 * Animates opacity/transform only, and collapses to a near-instant opacity
 * change when the user prefers reduced motion.
 */
export default function PageTransition({ children, className = "" }) {
  return (
    <motion.div
      {...reduced(pagePreset)}
      className={`gc-page ${className}`.trim()}
      style={{ display: "flex", flexDirection: "column", flex: "1 0 auto", minHeight: 0 }}
    >
      {children}
    </motion.div>
  );
}
